var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoCglDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 87.151,
    height: 17.187,
    viewBox: "0 0 87.151 17.187",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_102",
    "data-name": "Rectangle 102",
    width: 87.151,
    height: 17.187
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 86.954,
    height: 17.124
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "cgl_logo",
    "data-name": "cgl logo",
    transform: "translate(-13.099 -15.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_600",
    "data-name": "Group 600",
    transform: "translate(13.099 15.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_599",
    "data-name": "Group 599",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5020",
    "data-name": "Path 5020",
    d: "M105.271,24.666h3.082c.8,0,1.025-.233,1.025-1.043V21.274c0-.809-.23-1.043-1.025-1.043h-3.082c-.8,0-1.035.234-1.035,1.043v2.349c0,.81.232,1.043,1.035,1.043m-.313-3.85h3.707v3.249h-3.707Z",
    transform: "translate(-73.363 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5021",
    "data-name": "Path 5021",
    d: "M128.585,20.231H125v4.435h.723V22.93h2.859c.661,0,.931-.247.931-.853v-.993c0-.605-.27-.853-.931-.853m.2,1.657c0,.4-.173.476-.493.476h-2.566V20.789h2.566c.32,0,.493.076.493.477Z",
    transform: "translate(-87.095 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5022",
    "data-name": "Path 5022",
    d: "M146.917,24.073h-3.583V22.637H145.5V22.07h-2.167V20.807h3.548v-.576h-4.27v4.435h4.305v-.593",
    transform: "translate(-98.738 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5023",
    "data-name": "Path 5023",
    d: "M160.116,22.051a7.286,7.286,0,0,0-.052-.974l-.007-.049.025.043a1.71,1.71,0,0,0,.377.434l.07.065,3.425,3.1h.4V20.231h-.662v2.433a6.374,6.374,0,0,0,.069,1.095l.006.039-.024-.031a4.242,4.242,0,0,0-.509-.56l-3.329-2.976h-.452v4.435h.662V22.051",
    transform: "translate(-109.875 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5024",
    "data-name": "Path 5024",
    d: "M183.916,22.052h-3.535V20.231h-.721v4.435h.721v-2.02h3.535v2.02h.723V20.231h-.723v1.821",
    transform: "translate(-123.236 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5025",
    "data-name": "Path 5025",
    d: "M202.418,24.666h.8l-2.467-4.435h-.783l-2.423,4.435h.711l.569-1.1h3.026l.568,1.1m-3.294-1.646.008-.015,1.209-2.3.008.017,1.208,2.294Z",
    transform: "translate(-135.061 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5026",
    "data-name": "Path 5026",
    d: "M241.449,24.073h-3.583V22.637h2.167V22.07h-2.167V20.807h3.548v-.576h-4.271v4.435h4.305v-.593",
    transform: "translate(-161.247 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5027",
    "data-name": "Path 5027",
    d: "M254.65,22.051a7.294,7.294,0,0,0-.052-.974l-.006-.049.025.043a1.721,1.721,0,0,0,.375.434l.072.065,3.425,3.1h.4V20.231h-.662v2.433a6.345,6.345,0,0,0,.069,1.095l.006.039-.024-.031a4.33,4.33,0,0,0-.508-.56l-3.33-2.976h-.452v4.435h.662V22.051",
    transform: "translate(-172.385 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5028",
    "data-name": "Path 5028",
    d: "M114.49,43.382l-3.539,6.256h1.417l.732-1.378h4.014l.006.011.751,1.368h1.6l-3.589-6.256H114.49m-.79,3.783.016-.03,1.422-2.6.017.033,1.37,2.593Z",
    transform: "translate(-77.803 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5029",
    "data-name": "Path 5029",
    d: "M224.719,43.382l-3.54,6.256H222.6l.733-1.378h4.013l.006.011.75,1.368h1.6l-3.589-6.256h-1.391m-.791,3.783.016-.03,1.422-2.6.018.033,1.37,2.593Z",
    transform: "translate(-150.69 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5030",
    "data-name": "Path 5030",
    d: "M143.449,47.2l-.016-.021-2.958-3.8H139.32v6.256h1.143V45.766c0-.2-.011-.4-.037-.669l-.013-.14.052.131a2.759,2.759,0,0,0,.375.642l2.361,3.152h.272l2.361-3.141a4.068,4.068,0,0,0,.365-.655l.052-.108-.014.119a6.62,6.62,0,0,0-.049.669v3.872H147.5V43.382h-1.142l-2.913,3.82",
    transform: "translate(-96.562 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5031",
    "data-name": "Path 5031",
    d: "M171.246,46.892h2.9V45.86h-2.9V44.416h4.978V43.382h-6.4v6.256h6.463V48.494h-5.04v-1.6",
    transform: "translate(-116.731 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5032",
    "data-name": "Path 5032",
    d: "M203.007,43.382h-1.423v6.256h6.146V48.494h-4.722V43.382",
    transform: "translate(-137.733 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5033",
    "data-name": "Path 5033",
    d: "M255.36,46.432l-.156-.021.157-.019c.7-.085,1.068-.446,1.068-1.041v-.769c0-.841-.417-1.2-1.395-1.2h-5.373v6.256h4.982c1.234,0,1.834-.4,1.834-1.212v-.805a1.137,1.137,0,0,0-1.117-1.188m-4.3-2.065h3.363c.438,0,.691.077.691.472v.6c0,.394-.253.472-.691.472H251.06Zm4.091,3.6c0,.492-.245.581-.728.581H251.06V46.9h3.363c.615,0,.728.2.728.581Z",
    transform: "translate(-169.524 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5034",
    "data-name": "Path 5034",
    d: "M87.307,24.666H90.76c.055,0,.1,0,.152-.006h.019v-.595H86.995V20.816h3.936v-.577h0c-.061,0-.122-.008-.192-.008H87.307c-.8,0-1.035.234-1.035,1.043v2.349c0,.81.232,1.043,1.035,1.043",
    transform: "translate(-61.484 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5035",
    "data-name": "Path 5035",
    d: "M222.247,23.623V22.191h-2.526v.55h1.8v1.324h-3.509V20.816h4.23v-.578h-.027c-.043,0-.087-.005-.135-.005H218.33c-.8,0-1.035.234-1.035,1.043v2.349c0,.81.232,1.043,1.035,1.043h2.884c.8,0,1.034-.233,1.034-1.043",
    transform: "translate(-148.122 -18.666)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5036",
    "data-name": "Path 5036",
    d: "M87.673,43.382c-1.2,0-1.542.33-1.542,1.469v3.319c0,1.139.346,1.468,1.542,1.468h4.344c1.2,0,1.542-.329,1.542-1.468V46.018H89.78v1.034h2.391v1.442H87.555v-4.03h6.018V43.382h-5.9",
    transform: "translate(-61.391 -33.974)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5037",
    "data-name": "Path 5037",
    d: "M31.244,34.266v4.6h7.94V37.4h-6.49V34.266h-1.45",
    transform: "translate(-25.098 -27.946)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_604",
    "data-name": "Group 604",
    transform: "translate(13.099 15.662)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_603",
    "data-name": "Group 603",
    transform: "translate(0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_602",
    "data-name": "Group 602",
    transform: "translate(0 -0.052)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_601",
    "data-name": "Group 601",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_5038",
    "data-name": "Path 5038",
    d: "M36.342,25.015H22.257V35.883H36.342V28.149H28.456v1.466h6.432v4.8H23.706V26.481H36.342V25.015",
    transform: "translate(-19.155 -21.829)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5039",
    "data-name": "Path 5039",
    d: "M13.1,32.9H30.287V31.432H14.549v-14.2H30.287V15.763H13.1V32.9",
    transform: "translate(-13.099 -15.711)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCglDark);
export default __webpack_public_path__ + "static/media/logo-cgl-dark.7d72ab117cbae5edfbf5e4322d7c71c2.svg";
export { ForwardRef as ReactComponent };